import { AdminSubRouteConfig, SubRoutes } from "Components/Navigation/NavigationTypes";
import { CommitteeMeetings, CommitteeMembers, CommitteeOpenPositions, CommitteeProfile } from "Features/Committees";

export enum CommitteeSubRoute {
  Profile = '/Profile',
  Members = '/Members',
  Vacancies = '/Vacancies',
  Meetings = '/Meetings',
  OpenPositions = '/OpenPositions',
}

export type CommitteeSubRoutesProps = {
  isOpen?: boolean;
}

export const CommitteeSubRoutes: SubRoutes = {
  [CommitteeSubRoute.Profile]: new AdminSubRouteConfig(
    CommitteeSubRoute.Profile,
    'Profile',
    CommitteeProfile,
    true,
  ),
  [CommitteeSubRoute.Members]: new AdminSubRouteConfig(
    CommitteeSubRoute.Members,
    'Members',
    CommitteeMembers,
    false,
  ),
  [CommitteeSubRoute.Meetings]: new AdminSubRouteConfig(
    CommitteeSubRoute.Meetings,
    'Meetings',
    CommitteeMeetings,
    false,
  ),
};

export const OpenCommitteeSubRoutes: SubRoutes = {
  [CommitteeSubRoute.Profile]: new AdminSubRouteConfig(
    CommitteeSubRoute.Profile,
    'Profile',
    CommitteeProfile,
    true,
  ),
  [CommitteeSubRoute.Members]: new AdminSubRouteConfig(
    CommitteeSubRoute.Members,
    'Members',
    CommitteeMembers,
    false,
  ),
  [CommitteeSubRoute.Meetings]: new AdminSubRouteConfig(
    CommitteeSubRoute.Meetings,
    'Meetings',
    CommitteeMeetings,
    false,
  ),
  [CommitteeSubRoute.OpenPositions]: new AdminSubRouteConfig(
    CommitteeSubRoute.OpenPositions,
    'Open Positions',
    CommitteeOpenPositions,
    false,
  ),
};
